import { ApiClientService, useAuth, useUser } from '@dofleini/security';
import moment from 'moment';
import React, { createContext, useCallback, useContext, useEffect, useRef } from 'react';

import { authentication } from '@/settings';

const SessionControlContext = createContext();

const REFRESH_TOKEN_KEY = '__refresh_token__';
const SPACE_KEY = '__space__';
const EXPIRE_DATE_KEY = '__expire_date__';

export const setAuthData = (data = {}, remember = false) => {
  const { accessToken, refreshToken, space } = data;
  const storage = (remember ? window.localStorage : window.sessionStorage);
  storage.setItem(ApiClientService.ACCESS_TOKKEN_KEY, accessToken);
  storage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  storage.setItem(SPACE_KEY, space);
  storage.setItem(EXPIRE_DATE_KEY, moment().toString());
};

export const handleUserResponse = ({ data }) => {
  setAuthData(data, true);
  return data;
};

export const refreshToken = () => {
  const token = window.localStorage.getItem(ApiClientService.ACCESS_TOKKEN_KEY);
  const refresh = window.localStorage.getItem(REFRESH_TOKEN_KEY);
  const space = window.localStorage.getItem(SPACE_KEY);
  // remove to avoid header
  window.localStorage.removeItem(ApiClientService.ACCESS_TOKKEN_KEY);
  //
  return ApiClientService.post(`${authentication.path}/api/refresh-token`, {
    token,
    refresh,
    space
  }).then(handleUserResponse);
};

const SessionControlProvider = (props) => {
  const { user } = useUser();
  const { logout } = useAuth();
  const reloading = useRef(false);
  
  const refresh = useCallback(() => {
    if (!reloading.current) {
      reloading.current = true;
      refreshToken().then(() => {
        reloading.current = false;
      }).catch(({ status }) => {
        (status === 401) && logout();
      });
    }
  }, [logout]);
  
  useEffect(() => {
    if (!user) {
      return;
    }
    ApiClientService.onError(refresh, 401);
  }, [refresh, user]);
  
  return (
    <SessionControlContext.Provider value={{ refresh }} {...props}/>
  );
};

const useSessionControl = () => {
  const context = useContext(SessionControlContext);
  if (context === undefined) {
    throw new Error('useSessionControl must be used within a SessionControlProvider');
  }
  const { refresh } = context;
  return { refresh };
};

SessionControlProvider.propTypes = {};

export { SessionControlProvider, useSessionControl };
